import React from 'react';
import { Link } from 'react-router-dom';
import PageNavigation from '../components/PageNavigation';
import bagelImage from '../assets/images/bagel.jpeg';
import './Page.css';

function About() {
  return (
    <div className="page-container">
      <PageNavigation />
      <div className="page-content">
        <p className="page-text">
        <a 
          href="https://opensea.io/item/ethereum/0xfbeef911dc5821886e1dda71586d90ed28174b7d/625304" 
          target="_blank" 
          rel="noopener noreferrer"
          className="bagel-image-link"
        >
          <img src={bagelImage} alt="Everything Bagels" className="bagel-image" />
        </a>
        <br />  
        I'm eggy bagelface, <strong>bagelface</strong> for short, or bagel for shortest.
        <br />
        I'm not a good frontend dev, but I'm pretty good at everything else.
        <br />
        I'm always looking for new opportunities. My DMs are open.
        <br />
        <br />
        <a href="mailto:bagelface@protonmail.com">bagelface@protonmail.com</a>
        <br />
        bagelface.eth
        <br />
        <a href="https://x.com/0xbagelface" target="_blank" rel="noopener noreferrer">@0xbagelface</a>
        </p>
        <Link to="/" className="back-link">← PLAY WITH THE BAGEL</Link>
      </div>
    </div>
  );
}

export default About;
